import React from 'react';
import { Alert, Icon, Spin, Button } from 'antd';
import { incidenceMessages } from 'components/FormMap/FormMap.config';
import IconFromCoordinates from 'components/FormMap/IconFromCoordinates';
import FeatureAuthorisations from 'components/FeatureAuthorisations';
import Permissions from 'components/Permissions';

import styles from 'components/FormMap/FeatureMessage.module.scss';
import FeatureName from './FeatureName';

class FeatureMessage extends React.Component {
  state = {
    visible: false,
  };

  getCoordinatesToDisplay = () => {
    const {
      features,
      feature,
      feature: {
        geometry: { coordinates, type },
      },
    } = this.props;

    if (type !== 'LineString') {
      return coordinates;
    }

    return features.reduce((acc, feat) => {
      // Avoid others features
      if (feat.properties.relatedFeatureId !== feature.properties.relatedFeatureId) {
        return acc;
      }

      // Filter some doublons
      if (acc.some(item => item.join() === feat.geometry.coordinates.join())) {
        return acc;
      }

      return [...acc, feat.geometry.coordinates];
    }, []);
  }

  afterClose = () => {
    const {
      deleteFeatureById,
      feature: { properties: { id, relatedFeatureId } },
    } = this.props;

    deleteFeatureById(relatedFeatureId);
    deleteFeatureById(id);
  }

  showModal = () => {
    this.setState(previousState => ({ visible: !previousState.visible }));
  }

  render () {
    const {
      selectedFeaturesId,
      feature,
      feature: {
        properties: { id: featureId }, geometry: { type },
      },
      warning,
      id,
      activity = {},
      incidence,
      editable,
      updateFeatureName,
    } = this.props;
    const { visible } = this.state;
    const GRIDCODE = incidence ? incidence.GRIDCODE : -1;
    const message = incidence ? incidenceMessages[type][GRIDCODE] : incidenceMessages.pending;
    const {
      text: messageText,
      type: messageType = 'info',
      color: messageColor = '#666699',
    } = message;

    const hasAuthProp = activity.filters && activity.filters.reduce((acc, f) =>
      (!acc && f.includes('_AUT_') ? true : acc), false);

    return (
      <React.Fragment>
        <Alert
          message={(
            <React.Fragment>
              <IconFromCoordinates
                coordinates={this.getCoordinatesToDisplay()}
                className={styles.svg}
              />
              <FeatureName
                updateFeatureName={updateFeatureName}
                feature={feature}
                id={id}
                editable={editable}
              />
            </React.Fragment>
          )}
          description={(
            <React.Fragment>
              <div className={styles.incidenceFeature}>
                {incidence
                  ? <strong>Incidence sur la faune et la flore : </strong>
                  : <Spin size="small" className={styles.spinner} />
                }
                {messageText}
              </div>
              {warning && (
                <p><strong>Autre incidence (sécurité, érosion, etc.) : </strong>
                  {incidenceMessages.chemins.notAllowedPath}.
                </p>
              )}
              {!editable && type === 'LineString' && hasAuthProp && (
              <Permissions groups={['N2']}>
                <Button onClick={this.showModal}>
                    Modifier les autorisations pour ce parcours
                </Button>
              </Permissions>
              )}
            </React.Fragment>
          )}
          type={messageType}
          className={styles.descriptionFeature}
          closeText={editable && <Icon type="delete" className={styles.deleteFeature} style={{ color: messageColor }} />}
          afterClose={this.afterClose}
          banner={!selectedFeaturesId.includes(featureId) && GRIDCODE !== 4}
          showIcon={false}
        />
        <FeatureAuthorisations
          showModal={this.showModal}
          visible={visible}
          feature={feature}
          activity={activity}
        />
      </React.Fragment>
    );
  }
}

export default FeatureMessage;



// WEBPACK FOOTER //
// ./src/components/FormMap/FeatureMessage.js